var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7382 10.7693L19.9281 6.2603V15.2268L14.7382 10.7693ZM8.05062 11.5329L9.87312 13.1149C10.1591 13.3579 10.5321 13.5047 10.9396 13.5047H10.954H10.9531H10.9649C11.3733 13.5047 11.7462 13.3571 12.0356 13.1124L12.0331 13.1141L13.8556 11.5321L19.3957 16.29H2.51308L8.05062 11.5329ZM2.50549 5.19127H19.4058L11.2881 12.2416C11.2003 12.3108 11.089 12.353 10.9675 12.353C10.9632 12.353 10.9599 12.353 10.9556 12.353H10.9565C10.9531 12.353 10.9489 12.353 10.9447 12.353C10.8232 12.353 10.711 12.3108 10.6232 12.2408L10.6241 12.2416L2.50549 5.19127ZM1.98152 6.25946L7.17058 10.7685L1.98152 15.2235V6.25946ZM20.2065 4.19986C20.004 4.09861 19.7661 4.03955 19.5138 4.03955H2.39833C2.14521 4.04039 1.90558 4.09946 1.6938 4.20577L1.70308 4.20155C1.18165 4.46227 0.829803 4.99214 0.829803 5.60471V5.60808V15.8748C0.830647 16.7405 1.53265 17.4417 2.39749 17.4425H19.5113C20.377 17.4417 21.0781 16.7397 21.079 15.8748V5.60808C21.079 5.60724 21.079 5.60639 21.079 5.60471C21.079 4.9913 20.7254 4.45974 20.2107 4.20408L20.2015 4.19986H20.2065Z",
    fill: "#003A9B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_598"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.25,
    height: 20.25,
    fill: "white",
    transform: "translate(0.829773 0.664551)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.eecfd439cae0ded2aaa914c174944625.svg";
export { ForwardRef as ReactComponent };